import { render } from "./edit-staff-draw.vue?vue&type=template&id=41649071&scoped=true"
import script from "./edit-staff-draw.vue?vue&type=script&lang=js"
export * from "./edit-staff-draw.vue?vue&type=script&lang=js"

import "./edit-staff-draw.vue?vue&type=style&index=0&id=41649071&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41649071"]])

export default __exports__